import React from 'react';
import classes from './Container.css';
const container = (props) => (
    <div className={classes.appContainer} >
            {props.children}
    </div>
);


export default container;


// WEBPACK FOOTER //
// ./src/hoc/Container/Container.js